import paymentsTransactionsComponent from './payments-transactions.component';

const paymentsTransactionsModule = angular.module('paymentsTransactions', [
])
  .component('paymentsTransactions', paymentsTransactionsComponent)
  .name;

export default paymentsTransactionsModule;
